import { FormControl, FormField, FormItem, FormLabel, FormMessage, Textarea } from "@/shared/components";
import { FieldPath, FieldValues, UseFormReturn } from "react-hook-form";

export interface TextAreaFormFieldProps<T extends FieldValues> {
    form: UseFormReturn<T>;
    label?: string;
    name: FieldPath<T>;
    rows?: number;
    placeholder?: string;
    className?: string;
    readOnly?: boolean;
    maxLength?: number;
    tabIndex?: number;
    autoFocus?: boolean;
    "data-testid"?: string;
}

export function TextAreaFormField<T extends FieldValues>({
    form,
    label,
    name,
    rows = 5,
    placeholder,
    className,
    readOnly,
    maxLength,
    tabIndex,
    autoFocus,
    "data-testid": dataTestid,
}: Readonly<TextAreaFormFieldProps<T>>) {
    return (
        <FormField
            control={form.control}
            name={name}
            render={({ field }) => (
                <FormItem>
                    {label && <FormLabel>{label}</FormLabel>}
                    <FormControl>
                        {readOnly ? (
                            <span className="text-content-placeholder w-full px-3 py-2">{field.value || "Onbekend"}</span>
                        ) : (
                            <Textarea
                                className={className}
                                placeholder={placeholder}
                                data-testid={dataTestid}
                                maxLength={maxLength}
                                rows={rows}
                                tabIndex={tabIndex}
                                autoFocus={autoFocus}
                                {...field}
                            />
                        )}
                    </FormControl>
                    <FormMessage />
                </FormItem>
            )}
        />
    );
}
